import { memo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Mood } from '../types';

interface MoodPickerProps {
  selected: Mood;
  onChange: (mood: Mood) => void;
  disabled?: boolean;
}

export const MoodPicker = memo(function MoodPicker({ selected, onChange, disabled = false }: MoodPickerProps) {
  const { t } = useLanguage();
  
  const MOODS: Array<{ value: Mood; emoji: string; label: string }> = [
    { value: 'confident', emoji: '😎', label: t('predictor.mood.confident') },
    { value: 'nervous', emoji: '😰', label: t('predictor.mood.nervous') },
    { value: 'bold', emoji: '🎲', label: t('predictor.mood.bold') }
  ];

  return (
    <div className="space-y-3">
      <label className="block text-slate-600 text-xs uppercase tracking-wider font-semibold">
        {t('predictor.mood')}
      </label>
      <div className="grid grid-cols-3 gap-2.5">
        {MOODS.map((mood) => (
          <button
            key={mood.value}
            onClick={() => !disabled && onChange(mood.value)}
            disabled={disabled}
            className={`
              p-4 rounded-2xl border-2 transition-smooth relative overflow-hidden
              ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
              ${selected === mood.value 
                ? 'border-primary bg-gradient-to-br from-primary-light to-primary-lighter scale-105 shadow-md' 
                : 'border-slate-200 bg-white hover:border-primary/30 hover:shadow-sm active:scale-95'
              }
            `}
          >
            <div className="text-4xl mb-1.5">{mood.emoji}</div>
            <div className={`text-xs font-semibold ${selected === mood.value ? 'text-primary' : 'text-slate-600'}`}>
              {mood.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
});